import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPencil, fas, faTrash } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./BankDetails.css";
import AddOffCanvance from "./Add";
import { get } from "jquery";
import { deleteData, editStatusData } from "../../../../utils/api";

library.add(fas);

const BankDetails = (props) => {
  const { postData, getData, IMG_URL, isAllow } = useContext(Context);
  // const [imagePreview, setImagePreview] = useState(null);
  // const [errors, setErrors] = useState();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/masters/bank-detail/${id}`);
    GetData();
  };

  const handleDeleteRecord = async (id) => {
    if (!id) return;

    const isConfirmed = window.confirm(
      "Are you sure you want to delete this bank account?",
    );
    if (!isConfirmed) return; // exit if user cancels

    try {
      const response = await deleteData(`/masters/bank-detail/${id}`);
      if (response.success) {
        await GetData(); // refresh table
      } else {
        alert(response.message); // optional error message
      }
    } catch (error) {
      console.error("Error deleting record:", error);
    }
  };

  const [show, setShowAdd] = useState(false);
  const [id, setId] = useState(null);

  // Modal function
  const handleClose = () => {
    setShowAdd(false);
    GetData();
  };
  const handleShow = () => setShowAdd(true);

  const [data, setData] = useState([]);

  const GetData = async () => {
    const response = await getData(`/masters/bank-detail`);
    await setData(response?.data);
    // setFormData(response?.data);
  };

  useEffect(() => {
    GetData();
  }, []);

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  const handleSorting = async (sort_order, id) => {
    const response = await editStatusData(`/masters/bank-detail/sort/${id}`, {
      sort_order: sort_order,
    });
    GetData();
  };

  return (
    <>
      <div className="bank_detail_card_holder">
        <div className="d-flex justify-content-end mb-3">
          <Button
            className="add_btn"
            onClick={() => {
              handleShow();
              setId(null);
            }}
          >
            + Add Bank Details
          </Button>
        </div>

        <div className="row">
          {data?.map((item) => (
            <div className="col-xl-4 col-lg-6">
              <Card className="shadow-lg p-3 mb-5 bg-white rounded">
                <Card.Body>
                  <div className="top_btns_div">
                    <div className="iconbs_div">
                      <select
                        className="form-select form-select-sm inner_select"
                        value={item?.sort_order || ""}
                        onChange={(e) => {
                          const selectedValue = parseInt(e.target.value);
                          // You can call a function here to update sort order
                          // console.log("Selected position:", selectedValue);
                          handleSorting(selectedValue, item?.id);
                        }}
                      >
                        <option value="">Select Sort</option>
                        {data.map((_, index) => (
                          <option key={index + 1} value={index + 1}>
                            {index + 1}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="iconbs_div">
                      <FontAwesomeIcon
                        icon={faPencil}
                        className="inner_icon"
                        onClick={() => {
                          handleShow();
                          setId(item?.id);
                        }}
                      />
                    </div>
                    <div className="iconbs_div">
                      <FontAwesomeIcon
                        icon={faTrash}
                        className="inner_icon"
                        onClick={() => handleDeleteRecord(item?.id)}
                      />
                    </div>
                    <div className="iconbs_div">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          checked={item?.status}
                          disabled={!isAllow?.includes(12)}
                          onChange={() => {
                            ChangeStatus(item?.id);
                          }}
                          id={`flexSwitchCheckDefault${item?.id}`}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text_div">
                    <div className="row_div">
                      <div className="record_text_div">
                        <p className="label_text">Payment Type</p>
                        <p className="value_text">{item?.payment_type}</p>
                      </div>
                      {/* {item?.payment_type === "Bank"} */}
                      <>
                        {" "}
                        <div className="record_text_div">
                          <p className="label_text">Account Name</p>
                          <p className="value_text">
                            {item?.holder_name || "-"}
                          </p>
                        </div>
                        <div className="record_text_div">
                          <p className="label_text">Bank Name</p>
                          <p className="value_text">{item?.bank_name || "-"}</p>
                        </div>
                        <div className="record_text_div">
                          <p className="label_text">Acc No</p>
                          <p className="value_text">{item?.ac_no || "-"}</p>
                        </div>
                        <div className="record_text_div">
                          <p className="label_text">IFSC</p>
                          <p className="value_text">{item?.ifsc_code || "-"}</p>
                        </div>
                        <div className="record_text_div">
                          <p className="label_text">Branch</p>
                          <p className="value_text">{item?.firm_name || "-"}</p>
                        </div>
                      </>

                      {/* {item?.payment_type === "UPI"} */}
                      <>
                        {" "}
                        <div className="record_text_div">
                          <p className="label_text">UPI ID</p>
                          <p className="value_text">{item?.upi_id || "-"}</p>
                        </div>
                      </>
                    </div>
                  </div>
                  <Link to={`/bank-payments/${item?.id}`}>
                    <button className="btn btn-info mt-3">View Payments</button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
          id={id}
        />
      ) : (
        ""
      )}
    </>
  );
};
export default BankDetails;
